// extracted by mini-css-extract-plugin
export var confirmationHeader = "_x2-0";
export var confirmationIcon = "_x2-1";